import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ElementSettings } from 'ops/common/models/editor-viewer-element';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ElementSettingsService {
    private domain: string;

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getAll(): Promise<ElementSettings[]> {
        return await lastValueFrom(
            this.http.get<ElementSettings[]>(`${this.domain}/api/elementSettings`),
        );
    }

    async getAllByMimicId(mimicId: string): Promise<ElementSettings[]> {
        return await lastValueFrom(
            this.http.get<ElementSettings[]>(`${this.domain}/api/elementSettings/list/${mimicId}`),
        );
    }
}
